import { gql } from '@apollo/client';

export const ActivityUpcomingRostersFragments = gql`
  fragment ActivityUpcomingRosters on VOLUNTEER_ActivityType {
    nextUntil(until: $endDate)
  }
`;
